import { render, staticRenderFns } from "./details.vue?vue&type=template&id=2948f670&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import style0 from "./details.vue?vue&type=style&index=0&id=2948f670&prod&scoped=true&lang=css"
import style1 from "./details.vue?vue&type=style&index=1&id=2948f670&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f1c606d12331ca9397f00d9371f47138/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2948f670",
  null
  
)

export default component.exports